import {FC} from 'react';
import {Box, Button, styled, Tab} from '@mui/material';
import TabList from '@mui/lab/TabList';
import {SUMMARY_TABS, SUMMARY_TABS_LABELS} from '../../constants/summary-tabs.constants';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import {useNavigate} from 'react-router-dom';
import {changeContractTabsSummary} from '../../stores/contract-summary-tabs.store';

export const ContractSummaryHeader: FC = () => {
  const navigate = useNavigate();

  const handleBackClick = () => navigate('/contracts');

  return (
    <Container>
      <Button startIcon={<KeyboardReturnIcon />} onClick={handleBackClick}>
        Назад
      </Button>
      <TabList onChange={changeContractTabsSummary}>
        {Object.values(SUMMARY_TABS).map((key) => (
          <Tab key={key} label={SUMMARY_TABS_LABELS[key]} value={key} />
        ))}
      </TabList>
    </Container>
  );
};

const Container = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(7),
  borderBottom: `1px solid ${theme.palette.divider}`,
}));
